module.exports = __webpack_public_path__ + "static/media/invite_share.7453c70b.jpg";